export const BATCH_REQUEST_SIZE = 100;

export const LOAD_ERROR_MESSAGE =
	'An error occured when trying to load "Action Plan Cosure Reports" results.';

export default {
	BATCH_REQUEST_SIZE,
	LOAD_ERROR_MESSAGE
};
